import React from 'react';
import { Map } from 'immutable';
import PropTypes from 'prop-types';
import Accordion from '@Components/Accordion';
import FilterToggler from './FilterToggler';

import './withAccordionForFilter.custom.scss';
import './withAccordionForFilter.theme.scss';

export default function withAccordionForFilter(FilterComponent) {
  function AccordionForFilterWrapper(props) {
    const { filter, toggleFilter, customFilterConfig } = props;
    const expanded = filter.get('expanded');

    return (
      <Accordion
        timeout={100}
        animationClass="with-accordion-for-filter-accordion"
        beforeContent={
          <FilterToggler
            filter={filter}
            customFilterConfig={customFilterConfig}
            withBorderBottom={false}
            defaultColorAsInitial
            onClick={() => {
              toggleFilter(filter);
            }}
          />
        }
        open={expanded}
        content={<FilterComponent {...props} />}
      />
    );
  }

  AccordionForFilterWrapper.propTypes = {
    filter: PropTypes.instanceOf(Map).isRequired,
    toggleFilter: PropTypes.func.isRequired,
    customFilterConfig: PropTypes.object,
  };

  return AccordionForFilterWrapper;
}
